<div class="manual-img">
  <img src="/assets/remote-control/remotecontrol_jp.png" width=100%>
</div>
<div class="menu-button">
  <span [routerLink]='["/room/",roomService.room_no]'> メニューへ戻る </span>
</div>
